import React from 'react';
import { Layout } from 'react-admin';
import MyMenu from './MyMenu';
import AppBar from './AppBar';
import RouteGuard from './components/RouteGuard';
import MyNotification from './components/MyNotification';

const MyLayout = (props) => (
  <React.Fragment>
    <RouteGuard />
    <Layout
      {...props}
      menu={MyMenu}
      appBar={AppBar}
      notification={MyNotification}
    />
  </React.Fragment>
);

export default MyLayout;



// WEBPACK FOOTER //
// ./src/MyLayout.js